import React, {ReactComponentElement, useEffect, useState} from 'react';
import {View, Text, TouchableOpacity, StyleSheet} from 'react-native-web';
import ENV from '../../../environment';
import IframeZoom from './components/Zoom/IframeZoom';
import CCText from '@/Atoms/CCText';
import CCColors from '@/Utils/CCColors';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';
import Divider from '@/Atoms/Divider/Divider';
import {Dimensions, Modal, ScrollView} from 'react-native';
import {useNavigation, useRoute} from '@react-navigation/native';
import webinarStore from './store/zoomInfoStore';
import Loader from '@/Atoms/CCLoader/CCLoader';
import {ScreenName} from '@/navigators/StackConstants';
import ActivePuzzle from './components/ActivePuzzle/ActivePuzzle';
import useClassroomInfoApi from '@/Hooks/ClassroomInfoApi/useClassroomInfoApi';
import ComingSoon from '../ComingSoon';
import {useSocket} from '@/Hooks/UseSocket';
import CompletedPuzzle from './components/CompletedPuzzle/CompletedPuzzle';
import useGetActivePuzzleApi from '@/Hooks/ClassroomInfoApi/useGetActivePuzzleApi';
import Leaderboard from './components/Leaderboard/Leaderboard';
import Summary from './components/Summary/Summary';
import {FontSizes} from '@/Utils/Dimensions';
import CCButton from '@/Atoms/CCButton';
import CustomVideoPlayer from '@/Atoms/VideoPlayerWeb';
import {useVideoCourseByIdApi} from '@/Hooks/BooksApi/useBooksApi';
import ClassroomNotification from './utils/ClassroomNotification/ClassroomNotification';

const Classroom = ({dashboardData}) => {
  const {height: screenHeight} = Dimensions.get('window');
  const dynamicHeight = screenHeight - 120;
  const {first_name, last_name, username, mobile_number} =
    dashboardData?.user || {};
  const userName =
    first_name?.trim() || last_name?.trim()
      ? `${first_name ?? ''} ${last_name ?? ''}`.trim()
      : username?.trim() || mobile_number?.trim() || 'Guest';

  // Initialize webinarData state
  const [webinarData, setWebinarData] = useState(null);
  const [dataLoaded, setDataLoaded] = useState(false);
  const navigation = useNavigation();
  const [source, setSource] = useState('live');
  const [selectedVideo, setSelectedVideo] = useState({});

  const getVideoCourseByIdSuccess = data => {
    console.log('video data', data);
    setSelectedVideo(data?.data);
    setLoading(false);
  };

  const getVideoCourseByIdError = error => {};

  const {mutate: getVideoCourseById} = useVideoCourseByIdApi(
    getVideoCourseByIdSuccess,
    getVideoCourseByIdError,
  );

  // Load data from localStorage on component mount
  //  Local change
  useEffect(() => {
    const loadWebinarData = () => {
      try {
        const storedData = localStorage.getItem('ZoomUserData');
        console.log('Raw localStorage data:', storedData);

        // const storedData = {
        //   token:
        //     'WGkyamrvBkRU6DO58zWKnn4GXPjXnnZoCX7BIqkoS4Y.DQgAAAAVVupAJhZVZDBnTU44c1EwR2h5UFVFNHktVF9RAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA',
        //   meetingId: '92364693075',
        //   password: '818945',
        //   occurenceId: '1753828200001',
        //   meetingRole: first_name === 'Haricharann' ? 'host' : 'student',
        //   isZoomMeeting: 1,
        //   batchType: 'Foundation2',
        //   topic: 'X-Ray Attack',
        // };

        if (storedData) {
          const parsedData = JSON.parse(storedData);
          console.log('Parsed webinar data:', parsedData);
          setWebinarData(parsedData);
          setSource(parsedData.source);
          if (parsedData.source == 'recording') {
            getVideoCourseById({courseId: parsedData.videoId});
          }
          // setWebinarData(storedData);
        } else {
          console.error('No webinarData found in localStorage. Redirecting...');
          navigation.navigate(ScreenName.Books, {tab: 'meeting'});
        }
      } catch (error) {
        console.error('Error parsing webinarData from localStorage:', error);
        navigation.navigate(ScreenName.Books, {tab: 'meeting'});
      } finally {
        setDataLoaded(true);
      }
    };

    loadWebinarData();
  }, []); // Empty dependency array - runs only once on mount

  // Extract data from webinarData once it's loaded

  const {
    token,
    meetingId,
    password,
    occurenceId,
    meetingRole,
    isZoomMeeting,
    batchType,
    topic,
  } = webinarData || {};

  const {schema, cc_ws_client} = require('../../../CCClientSdk');
  const [activeTabLeft, setActiveTabLeft] = useState<number>(0);
  const [activeTabRight, setActiveTabRight] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(true);
  const [isExitingFullscreen, setIsExitingFullscreen] = useState(false);

  const userEmail =
    isZoomMeeting === 1
      ? dashboardData?.user?.email
      : meetingRole === 'host'
      ? 'support@circlechess.com'
      : dashboardData?.user?.email;
  const userId: string = dashboardData?.user?.user_id;

  const [currentActivePuzzle, setCurrentActivePuzzle] = useState({
    puzzleId: '',
    puzzleName: '',
    totalMoveCount: '',
    startingFEN: '',
    orientation: '',
    puzzleTime: '',
    createdAt: '',
    remainingTime: '',
  });
  const [pastPuzzleId, setPastPuzzleId] = useState<number>(0);
  const [solvedActivePuzzle, setSolvedActivePuzzle] = useState<boolean>(false);
  const [notificationState, setNotificationState] = useState({
    data: null,
    isVisible: false,
  });

  // Initialize zoomMeetingInfo only after webinarData is loaded
  const [zoomMeetingInfo, setZoomMeetingInfo] = useState<{
    meetingId: string;
    tk: string;
    pwd: string;
    signature: string;
    userName: string;
    userEmail: string;
  }>({
    meetingId: '',
    tk: '',
    pwd: '',
    signature: '',
    userName: '',
    userEmail: '',
  });

  // Update zoomMeetingInfo when webinarData is available
  useEffect(() => {
    if (webinarData && dataLoaded) {
      console.log('Updating zoomMeetingInfo with webinarData:', webinarData);
      setZoomMeetingInfo({
        meetingId: `${meetingId || ''}`,
        tk: `${token || ''}`,
        pwd: `${password || ''}`,
        signature: '',
        userName: `${userName}`,
        userEmail: `${userEmail || ''}`,
      });
    }
  }, [
    webinarData,
    dataLoaded,
    meetingId,
    token,
    password,
    userName,
    userEmail,
  ]);

  const tabsLeft = [
    {
      key: 'Coach Screen',
      label: 'Coach Screen',
      icon: 'monitor',
      component: source == 'recording' ? CustomVideoPlayer : IframeZoom,
      getProps: () =>
        source == 'recording'
          ? {
              selectedVideo,
              setCurrentActivePuzzle,
            }
          : {
              zoomMeetingInfo,
              meetingRole,
              isZoomMeeting,
            },
    },
    {
      key: 'Past Puzzles',
      label: 'Past Puzzles',
      icon: 'check-circle-outline',
      component: CompletedPuzzle,
      getProps: () => ({
        meetingRole,
        meetingId,
        occurenceId,
        activeTabLeft,
        source,
      }),
      uniqueKey: pastPuzzleId || 'no-past-puzzle',
    },
    {
      key: 'Active Puzzle',
      label: 'Active Puzzle',
      icon: 'puzzle-outline',
      component: ActivePuzzle,
      getProps: () => ({
        meetingId,
        occurenceId,
        meetingRole,
        topic,
        currentActivePuzzle,
        isActiveTab: activeTabLeft === 2 ? true : false,
        setActiveTabLeft,
        setSolvedActivePuzzle,
        source,
      }),
      uniqueKey: currentActivePuzzle?.puzzleId || 'no-puzzle',
    },
  ];

  const tabsRight = [
    // {
    //   key: 'Chat Room',
    //   label: 'Chat Room',
    //   icon: 'chat',
    //   component: () => <Text>Coming soon.</Text>,
    //   getProps: () => ({
    //     // dashboardData,
    //   }),
    // },
    {
      key: 'Leaderboard',
      label: 'Leaderboard',
      icon: 'chart-box-outline',
      component: Leaderboard,
      getProps: () => ({
        meetingRole,
        meetingId,
        occurenceId,
        source,
        currentActivePuzzle,
        activeTabRight,
      }),
    },
    {
      key: 'Summary',
      label: 'Summary',
      icon: 'note-text-outline',
      component: Summary,
      getProps: () => ({
        meetingId,
        occurenceId,
        currentActivePuzzle,
        meetingRole,
        solvedActivePuzzle,
        activeTabRight,
        source,
      }),
      uniqueKey: currentActivePuzzle?.puzzleId || 'no-puzzle',
    },
  ];

  const socket = useSocket();

  const handleExitFullScreen = () => {
    console.log('Exit Full Screen 1');

    const isFullscreen = !!(
      document.fullscreenElement ||
      document.mozFullScreenElement ||
      document.webkitFullscreenElement ||
      document.msFullscreenElement
    );

    if (!isFullscreen) {
      console.log('Not in fullscreen mode');
      return;
    }

    console.log('Exit Full Screen 2 - Document is in fullscreen');

    const exitFullscreen = async () => {
      try {
        if (document.exitFullscreen) {
          console.log('Exit Full Screen 3 - Using exitFullscreen');
          await document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          console.log('Exit Full Screen 3 - Using mozCancelFullScreen');
          await document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          console.log('Exit Full Screen 3 - Using webkitExitFullscreen');
          await document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          console.log('Exit Full Screen 3 - Using msExitFullscreen');
          await document.msExitFullscreen();
        }
        console.log('Exit Full Screen 4 - Successfully exited fullscreen');
      } catch (error) {
        console.error('Error while exiting fullscreen:', error);

        if (error.message?.includes('Document not active')) {
          console.log('Attempting to focus window and retry...');
          try {
            window.focus();
            setTimeout(async () => {
              try {
                if (document.exitFullscreen) {
                  await document.exitFullscreen();
                } else if (document.mozCancelFullScreen) {
                  await document.mozCancelFullScreen();
                } else if (document.webkitExitFullscreen) {
                  await document.webkitExitFullscreen();
                } else if (document.msExitFullscreen) {
                  await document.msExitFullscreen();
                }
                console.log('Successfully exited fullscreen after refocus');
              } catch (retryError) {
                console.error(
                  'Failed to exit fullscreen even after refocus:',
                  retryError,
                );
              }
            }, 100);
          } catch (focusError) {
            console.error('Failed to focus window:', focusError);
          }
        }
      }
    };

    if (!document.hasFocus()) {
      console.log('Document does not have focus, attempting to focus...');
      window.focus();
      setTimeout(() => {
        exitFullscreen();
      }, 100);
    } else {
      console.log('Document has focus, proceeding with exit fullscreen');
      exitFullscreen();
    }
  };

  useEffect(() => {
    if (
      dataLoaded &&
      meetingRole !== 'student' &&
      localStorage.getItem('meetingStarted')
    ) {
      console.log('Meeting role inside leave', meetingRole);
      const handleBeforeUnload = event => {
        // setCloseModal(true);
        console.log('beforeunload event triggered');
        event.returnValue = 'Are you sure you want to leave?';
        return 'Are you sure you want to leave?';
      };
      window.addEventListener('beforeunload', handleBeforeUnload);
      return () => {
        window.removeEventListener('beforeunload', handleBeforeUnload);
      };
    }
  }, [dataLoaded]);

  const checkActivePuzzle = (webSocket, wsData) => {
    console.log('WebSocket works? ', webSocket, 'Data received', wsData);

    if (!isExitingFullscreen) {
      setIsExitingFullscreen(true);
      handleExitFullScreen();
      setTimeout(() => setIsExitingFullscreen(false), 500);
    }
    if (
      zoomMeetingInfo.signature &&
      zoomMeetingInfo.meetingId &&
      zoomMeetingInfo.tk &&
      zoomMeetingInfo.pwd
    ) {
      getActivePuzzle({
        meetingId: zoomMeetingInfo.meetingId,
        occurenceId,
      });
    }
    setActiveTabLeft(2);
    setActiveTabRight(0);
    setSolvedActivePuzzle(false);
  };

  const handleOnSuccessClassroomInfo = data => {
    console.log('Signature received?', data);
    setZoomMeetingInfo(prev => ({...prev, signature: data?.signature}));
  };

  const handleOnSuccessGetActivePuzzle = data => {
    console.log('handleOnSuccessGetActivePuzzle data?', data);
    setCurrentActivePuzzle({
      puzzleId: data?.active_puzzle?.puzzle_id,
      puzzleName: data?.active_puzzle?.puzzle_name,
      totalMoveCount: data?.active_puzzle?.total_move_count,
      startingFEN: data?.active_puzzle?.starting_fen,
      orientation: data?.active_puzzle?.orientation,
      puzzleTime: data?.active_puzzle?.puzzle_time,
      createdAt: data?.active_puzzle?.created_at,
      remainingTime: data?.active_puzzle?.remaining_time,
    });
  };

  const {mutate: getClassroomInfo} = useClassroomInfoApi(
    handleOnSuccessClassroomInfo,
  );

  const {mutate: getActivePuzzle} = useGetActivePuzzleApi(
    handleOnSuccessGetActivePuzzle,
  );

  const handleClassroomNotification = wsData => {
    try {
      let classroomNotificationParsed = wsData.message;
      if (typeof classroomNotificationParsed === 'string') {
        classroomNotificationParsed = JSON.parse(classroomNotificationParsed);
      }

      if (typeof classroomNotificationParsed === 'string') {
        classroomNotificationParsed = JSON.parse(classroomNotificationParsed);
      }
      console.log(
        'Received classroom notification:',
        classroomNotificationParsed,
      );
      setNotificationState({
        data: classroomNotificationParsed,
        isVisible: true,
      });
    } catch (error) {
      console.error('Error parsing classroom notification:', error);
    }
  };

  const handleNotificationClose = () => {
    setNotificationState({
      data: null,
      isVisible: false,
    });
  };

  // const {mutate: endClassroomMeeting} = useClassroomEndMeetingApi();

  // Only run this effect when zoomMeetingInfo is properly initialized
  useEffect(() => {
    console.log('Zoom info from server in useEffect', zoomMeetingInfo);
    if (
      zoomMeetingInfo.signature &&
      zoomMeetingInfo.meetingId &&
      zoomMeetingInfo.tk &&
      zoomMeetingInfo.pwd
    ) {
      setLoading(false);
    }
  }, [zoomMeetingInfo]);

  // WebSocket setup - only run when we have the required data
  useEffect(() => {
    if (socket && zoomMeetingInfo.signature && source !== 'recording') {
      console.log('websocket present');
      socket.registerMessageType(
        'classroom_puzzle_created',
        schema.classroomCreatePuzzle,
      );
      socket.registerMessageType(
        'classroom_notification',
        schema.classroomNotification,
      );
      console.log('websocket messageType');
      socket.registerMessageHandler(
        'classroom_puzzle_created',
        function (webSocket: any, wsData: any) {
          checkActivePuzzle(webSocket, wsData);
        },
      );
      socket.registerMessageHandler(
        'classroom_notification',
        function (webSocket: any, wsData: any) {
          handleClassroomNotification(wsData);
        },
      );
      console.log('websocket messageHandler');
    }
  }, [socket, zoomMeetingInfo.signature, source]);

  useEffect(() => {
    console.log(
      'Current Active Puzzle from Server in useEffect',
      currentActivePuzzle,
    );
  }, [currentActivePuzzle]);

  // Get classroom info - only run when we have the required data
  useEffect(() => {
    if (
      dataLoaded &&
      webinarData &&
      !zoomMeetingInfo.signature &&
      zoomMeetingInfo.meetingId &&
      zoomMeetingInfo.tk &&
      zoomMeetingInfo.pwd &&
      userId
    ) {
      console.log('Getting classroom info with:', {
        meetingId: zoomMeetingInfo.meetingId,
        userId,
        occurenceId,
        meetingRole,
        batchType,
      });
      getClassroomInfo({
        meetingId: zoomMeetingInfo.meetingId,
        userId,
        occurenceId,
        meetingRole,
        batchType,
      });
    }
  }, [
    dataLoaded,
    webinarData,
    zoomMeetingInfo.signature,
    zoomMeetingInfo.meetingId,
    zoomMeetingInfo.tk,
    zoomMeetingInfo.pwd,
    userId,
    occurenceId,
    meetingRole,
    batchType,
  ]);

  // Get active puzzle - only run when we have the required data
  useEffect(() => {
    if (
      dataLoaded &&
      webinarData &&
      zoomMeetingInfo.meetingId &&
      occurenceId &&
      zoomMeetingInfo.signature &&
      source !== 'recording'
    ) {
      console.log('Getting active puzzle with:', {
        meetingId: zoomMeetingInfo.meetingId,
        occurenceId,
      });
      getActivePuzzle({
        meetingId: zoomMeetingInfo.meetingId,
        occurenceId,
      });
    }
  }, [
    dataLoaded,
    webinarData,
    zoomMeetingInfo.meetingId,
    occurenceId,
    zoomMeetingInfo.signature,
    source,
  ]);

  useEffect(() => {
    if (tabsLeft[activeTabLeft].label === 'Past Puzzles') {
      setPastPuzzleId(prev => prev + 1);
    }
  }, [activeTabLeft]);

  //Local Change
  useEffect(() => {
    return () => {
      localStorage.removeItem('ZoomUserData');
    };
  }, []);

  return (
    <>
      <Loader loading={loading} textToShow={'Loading Your Classroom'} />
      <ClassroomNotification
        notificationData={notificationState.data}
        handleNotificationClose={handleNotificationClose}
        showPopUp={notificationState.isVisible}
      />
      <Divider width={1} />
      <View style={styles.container}>
        <Divider width={1} isVertical={true} />
        {/* Container 1 - Left 70% */}
        <View style={styles.leftTabsContainer}>
          <View style={styles.tab}>
            {tabsLeft.map((tab, tabIndex) => (
              <TouchableOpacity
                key={tab.label}
                onPress={() => setActiveTabLeft(tabIndex)}>
                <View
                  style={[
                    styles.tab,
                    activeTabLeft === tabIndex && styles.activeTab,
                  ]}>
                  <Icon
                    name={tab.icon}
                    size={20}
                    color={
                      activeTabLeft === tabIndex
                        ? CCColors.TextColor.Primary
                        : CCColors.TextColor.LightGrey
                    }
                  />
                  <CCText
                    style={[
                      styles.leftTabTitle,
                      activeTabLeft === tabIndex && styles.activeTab,
                    ]}
                    fontSize={14}>
                    {tab.label}
                  </CCText>
                </View>
                <View
                  style={[
                    activeTabLeft === tabIndex
                      ? styles.tabUnderline
                      : {marginTop: 10},
                  ]}
                />
              </TouchableOpacity>
            ))}
          </View>
          <Divider width={1} />
          {/* Tab Content */}
          <View
            style={[styles.leftTabContentContainer, {height: dynamicHeight}]}>
            {tabsLeft.map((tab, tabIndex) => {
              const {component: LeftComponent, getProps} = tab;
              return (
                <View
                  key={tab.uniqueKey ?? tabIndex}
                  style={[
                    styles.leftTabContent,
                    activeTabLeft === tabIndex && styles.leftTabActiveContent,
                    activeTabLeft !== tabIndex && {display: 'none'},
                  ]}>
                  {zoomMeetingInfo.signature !== '' || source == 'recording' ? (
                    <LeftComponent {...(getProps ? getProps() : {})} />
                  ) : (
                    <CCText>Loading Your Class</CCText>
                  )}
                </View>
              );
            })}
          </View>
        </View>
        {meetingRole !== 'mentor' && (
          <>
            <Divider width={1} isVertical={true} />
            {/* Container 2 - Right 30% */}
            <View style={styles.rightTabsContainer}>
              <View style={styles.tab}>
                <ScrollView horizontal showsHorizontalScrollIndicator={false}>
                  {tabsRight.map((tab, tabIndex) => (
                    <TouchableOpacity
                      key={tab.label}
                      onPress={() => setActiveTabRight(tabIndex)}>
                      <View
                        style={[
                          styles.tab,
                          activeTabRight === tabIndex && styles.activeTab,
                        ]}>
                        <Icon
                          name={tab.icon}
                          size={20}
                          color={
                            activeTabRight === tabIndex
                              ? CCColors.TextColor.Primary
                              : CCColors.TextColor.LightGrey
                          }
                        />
                        <CCText
                          style={[
                            styles.rightTabTitle,
                            activeTabRight === tabIndex && styles.activeTab,
                          ]}
                          fontSize={14}>
                          {tab.label}
                        </CCText>
                      </View>
                      <View
                        style={[
                          activeTabRight === tabIndex
                            ? styles.tabUnderline
                            : {marginTop: 10},
                        ]}
                      />
                    </TouchableOpacity>
                  ))}
                </ScrollView>
              </View>
              <Divider width={1} />
              {/* Tab Content */}
              <View
                style={[
                  styles.rightTabContentContainer,
                  {height: dynamicHeight},
                ]}>
                {tabsRight.map((tab, tabIndex) => {
                  const {component: RightComponent, getProps} = tab;
                  return (
                    <View
                      key={tab.uniqueKey || tabIndex}
                      style={[
                        styles.rightTabContent,
                        activeTabRight !== tabIndex && {display: 'none'},
                      ]}>
                      {activeTabRight === tabIndex &&
                        (zoomMeetingInfo.signature !== '' ||
                          source == 'recording') && (
                          <RightComponent {...(getProps ? getProps() : {})} />
                        )}
                    </View>
                  );
                })}
              </View>
            </View>
          </>
        )}
      </View>
    </>
  );
};

export default Classroom;

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    // flex: 1,
    // flexWrap: 'wrap',
    backgroundColor: CCColors.Primary.lightBrown,
  },
  leftTabsContainer: {
    // flexDirection: 'column',
    flex: 7,
    justifyContent: 'flex-start',
  },
  rightTabsContainer: {
    flex: 3,
    justifyContent: 'flex-start',
  },
  tab: {
    paddingHorizontal: 10,
    padding: 10,
    paddingTop: 7,
    paddingBottom: 0,
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexDirection: 'row',
    backgroundColor: CCColors.White,
  },
  activeTab: {
    fontWeight: 'bold',
  },
  tabUnderline: {
    marginTop: 7,
    height: 2,
    backgroundColor: CCColors.Primary.Default,
  },
  leftTabTitle: {
    marginLeft: 8,
    marginRight: 20,
    // marginBottom: 10,
    color: CCColors.TextColor.Primary,
  },
  rightTabTitle: {
    marginLeft: 8,
    marginRight: 8,
    // marginBottom: 10,
    color: CCColors.TextColor.Primary,
  },
  leftTabContentContainer: {
    position: 'relative',
    // height: '70%',
    backgroundColor: CCColors.Primary.lightBrown,
    //backgroundColor: 'blue',
  },
  leftTabContent: {
    paddingHorizontal: 15,
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 1,
    opacity: 0,
    pointerEvent: 'none',
  },
  leftTabActiveContent: {zIndex: 2, opacity: 1, pointerEvents: 'auto'},
  rightTabContentContainer: {
    // height: '70%',
    backgroundColor: CCColors.White,
  },
  rightTabContent: {
    flex: 1,
    paddingHorizontal: 8,
    width: '100%',
    height: '100%',
  },
  contentContainer: {
    paddingTop: 20,
  },
});
